module.exports = __webpack_public_path__ + "static/media/YF02_2.a3e42c1a.jpg";